/**
 * メッセージよりLambdaのErrorコードを取得する
 *
 * Lambdaで発生したエラーではエラーコードを直接受け取れるわけではなく、以下のような形式のメッセージを受け取ることができる
 * 「PreTokenGeneration failed with error CODE=XXXXXXXXXX,MESSAGE=XXXXXXXXXX. (Service: AWSCognitoIdentityProviderInternalService...」
 * そのため、正規表現を用いてErrorコードの部分を抽出する
 */
export const getLambdaErrorCode = (message: string) => {
    // safariでは肯定後読みができないため一旦CODE=XXXXの形でとりだしてからCODE=を削る
    return message.match(/CODE=.*(?=,MESSAGE)/)?.[0]?.slice(5);
};
